import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    root: {
        marginTop: 15,
        marginLeft: 5,
        marginRight: 5
    },
    gridTop: {
        maxHeight: 50,
        padding: 8
    },
    textTopRight: {
        color: theme.palette.primary.contrastText,
    },
    textTopLeft: {
        color: theme.palette.primary.contrastText,
        textAlign: 'left'
    },
    gridBottom: {
        padding: 10
    },
    literText: {
        fontSize: 15,
        fontWeight: 'bold',
        paddingLeft: 2
    },
    gridBottomText: {
        textAlign: 'left'
    },
    gridIcon: {
        display: 'flex', flexDirection: 'row'
    },
    iconDec: {
        color: theme.palette.primary.main,
        marginLeft: 5
    },
    iconInc: {
        color: theme.palette.color.green,
        marginLeft: 5
    }
}))
